<template>
  <b-row>
    <b-col
      cols="12"
      md="7"
    >
      <services-table />
    </b-col>
    <b-col
      cols="12"
      md="5"
    >
      <OffersTable />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import OffersTable from '@/views/Dashboard/components/OffersTable.vue'
import ServicesTable from '@/views/Dashboard/components/ServicesTable.vue'

export default {
  name: 'DashboardIndex',
  components: {
    BRow,
    BCol,
    OffersTable,
    ServicesTable,
  },
}
</script>
